import { useLocalStorage } from '@vueuse/core'

const ACCENT_COLORS = {
    yellow: {
        name: 'Golden',
        light: { primary: '115 75 0', onPrimary: '255 255 255', container: '255 235 130', onContainer: '40 20 0' },
        dark: { primary: '240 190 30', onPrimary: '40 20 0', container: '65 40 0', onContainer: '255 235 130' }
    },
    orange: {
        name: 'Tangerine',
        light: { primary: '200 75 0', onPrimary: '255 255 255', container: '255 210 180', onContainer: '55 20 0' },
        dark: { primary: '255 160 50', onPrimary: '55 20 0', container: '80 50 0', onContainer: '255 210 180' }
    },
    pink: {
        name: 'Blush',
        light: { primary: '180 30 100', onPrimary: '255 255 255', container: '255 200 220', onContainer: '50 5 25' },
        dark: { primary: '255 130 180', onPrimary: '50 5 25', container: '100 20 60', onContainer: '255 200 220' }
    },
    purple: {
        name: 'Lavender',
        light: { primary: '120 40 180', onPrimary: '255 255 255', container: '240 210 255', onContainer: '40 10 65' },
        dark: { primary: '210 150 255', onPrimary: '40 10 65', container: '70 20 100', onContainer: '240 210 255' }
    },
    blue: {
        name: 'Ocean',
        light: { primary: '0 100 200', onPrimary: '255 255 255', container: '200 220 255', onContainer: '0 25 60' },
        dark: { primary: '130 180 255', onPrimary: '0 25 60', container: '0 60 120', onContainer: '200 220 255' }
    },
    teal: {
        name: 'Seafoam',
        light: { primary: '0 130 130', onPrimary: '255 255 255', container: '180 230 230', onContainer: '0 35 35' },
        dark: { primary: '100 200 200', onPrimary: '0 35 35', container: '0 70 70', onContainer: '180 230 230' }
    },
    green: {
        name: 'Forest',
        light: { primary: '30 130 60', onPrimary: '255 255 255', container: '200 240 210', onContainer: '5 40 15' },
        dark: { primary: '130 220 150', onPrimary: '5 40 15', container: '15 80 40', onContainer: '200 240 210' }
    }
}

function applyAccentColor(colorName, isDarkMode) {
    const color = ACCENT_COLORS[colorName]
    if (!color) return

    const palette = isDarkMode ? color.dark : color.light
    const root = document.documentElement

    root.style.setProperty('--m3-primary', palette.primary)
    root.style.setProperty('--m3-on-primary', palette.onPrimary)
    root.style.setProperty('--m3-primary-container', palette.container)
    root.style.setProperty('--m3-on-primary-container', palette.onContainer)

    const metaThemeColors = document.querySelectorAll('meta[name="theme-color"]')
    const hexColor = `rgb(${palette.primary})`
    if (metaThemeColors.length > 0) {
        metaThemeColors.forEach(meta => {
            meta.setAttribute('content', hexColor)
        })
    } else {
        const meta = document.createElement('meta')
        meta.name = 'theme-color'
        meta.content = hexColor
        document.head.appendChild(meta)
    }
}

export function useAccentColor() {
    const accentColor = useLocalStorage('accentColor', 'blue')

    const initAccentColor = (isDarkMode = false) => {
        const colorName = ACCENT_COLORS[accentColor.value] ? accentColor.value : 'blue'
        accentColor.value = colorName
        applyAccentColor(colorName, isDarkMode)
    }

    const setAccentColor = (colorName, isDarkMode = false) => {
        if (!ACCENT_COLORS[colorName]) return
        
        accentColor.value = colorName
        applyAccentColor(colorName, isDarkMode)
    }

    return {
        accentColor,
        accentColors: ACCENT_COLORS,
        initAccentColor,
        setAccentColor
    }
}
